import { emptyError } from "../../Types/ServicesType/servicesType";
import api from "@services/apiList";
import instance from "@services/services";
const {reportsApi,receptionApi}=api


export const encounterListReportService = async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.encounterListReportSearch,data)
        return result.data
    } catch (error) {
        return emptyError
    }
}
export const encounterListReportpdfService = async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.encounterListReportSearchpdf,data)
        return result.data
    } catch (error) {
        return emptyError
    }
}
export const encounterListReportexcelService = async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.encounterListReportSearchexcel,data)
        return result.data
    } catch (error) {
        return emptyError
    }
}


export const getAllDoctor=async()=>{
    try {
        const result=await instance.get(receptionApi.getallDoctor)
        return result.data.response
    } catch (error) {
        return emptyError
    }
}